export const hebrewLOT = [
    // AltGr+Shift state (Alt+Ctrl+Shift) - @X patterns (must come before single chars)
    { match: /@2/, replace: "\u05AE" }, // zinor (AltGr+Shift+2)
    { match: /@3/, replace: "\u0599" }, // pashta (AltGr+Shift+3)
    { match: /@4/, replace: "\u05A0" }, // telisha gedola (AltGr+Shift+4)
    { match: /@5/, replace: "\u05A9" }, // telisha qetana (AltGr+Shift+5)
    { match: /@7/, replace: "\u05A1" }, // pazer (AltGr+Shift+7)
    { match: /@8/, replace: "\u0595" }, // zaqef gadol (AltGr+Shift+8)
    { match: /@9/, replace: "\u0593" }, // shalshelet (AltGr+Shift+9)
    { match: /@0/, replace: "\u05AF" }, // masora circle (AltGr+Shift+0)
    { match: /@-/, replace: "\u05BF" }, // rafe (AltGr+Shift+-)
    { match: /@\\/, replace: "\u05AB" }, // ole (AltGr+Shift+\)
    { match: /@E/, replace: "\u05B1" }, // hataf segol (AltGr+Shift+E)
    { match: /@A/, replace: "\u05B2" }, // hataf patah (AltGr+Shift+A)
    { match: /@O/, replace: "\u05B3" }, // hataf qamats (AltGr+Shift+O)
    { match: /@\[/, replace: "\u0594" }, // zaqef qatan (AltGr+Shift+[)
    { match: /@]/, replace: "\u0592" }, // segolta (AltGr+Shift+])
    { match: /@;/, replace: "\u05C3" }, // sof pasuq (AltGr+Shift+;)
    { match: /@'/, replace: "\u05C4" }, // punctum (AltGr+Shift+')

    // AltGr state (Alt+Ctrl) - $X patterns (must come before single chars)
    { match: /\$1/, replace: "\u05BD" }, // meteg (AltGr+1)
    { match: /\$3/, replace: "\u0596" }, // tipeha (AltGr+3)
    { match: /\$4/, replace: "\u05A5" }, // merkha (AltGr+4)
    { match: /\$5/, replace: "\u05A6" }, // merkha kefula (AltGr+5)
    { match: /\$6/, replace: "\u05AD" }, // dehi (AltGr+6)
    { match: /\$7/, replace: "\u05A3" }, // munah (AltGr+7)
    { match: /\$8/, replace: "\u059B" }, // tevir (AltGr+8)
    { match: /\$9/, replace: "\u05A7" }, // darga (AltGr+9)
    { match: /\$0/, replace: "\u05AA" }, // yerah ben yomo (AltGr+0)
    { match: /\$=/, replace: "\u0591" }, // etnahta (AltGr+=)
    { match: /\$\\/, replace: "\u05A4" }, // mahapakh (AltGr+\)
    { match: /\$]/, replace: "\u059A" }, // yetiv (AltGr+])
    { match: /\$;/, replace: ";" },      // semicolon (AltGr+;)
    { match: /\$\//, replace: "׳" },     // geresh (punctuation) (AltGr+/)

    // Normal state (lowercase)
    { match: /a/, replace: "ַ" },      // patah
    { match: /b/, replace: "ב" },      // bet
    { match: /c/, replace: "צ" },      // tsadi
    { match: /d/, replace: "ד" },      // dalet
    { match: /e/, replace: "ֶ" },      // segol
    { match: /f/, replace: "שׂ" },     // sin (with dot)
    { match: /g/, replace: "ג" },      // gimel
    { match: /h/, replace: "ה" },      // he
    { match: /i/, replace: "ִ" },      // hiriq
    { match: /j/, replace: "שׁ" },     // shin (with dot)
    { match: /k/, replace: "כ" },      // kaf
    { match: /l/, replace: "ל" },      // lamed
    { match: /m/, replace: "מ" },      // mem
    { match: /n/, replace: "נ" },      // nun
    { match: /o/, replace: "ֹ" },      // holam
    { match: /p/, replace: "פ" },      // pe
    { match: /q/, replace: "ק" },      // qof
    { match: /r/, replace: "ר" },      // resh
    { match: /s/, replace: "ס" },      // samekh
    { match: /t/, replace: "ת" },      // tav
    { match: /u/, replace: "ֻ" },      // qubuts
    { match: /v/, replace: "ט" },      // tet
    { match: /w/, replace: "ו" },      // vav
    { match: /x/, replace: "ח" },      // het
    { match: /y/, replace: "י" },      // yod
    { match: /z/, replace: "ז" },      // zayin
    { match: /;/, replace: "ְ" },      // sheva
    { match: /=/, replace: "ּ" },      // dagesh
    { match: /-/, replace: "־" },      // maqaf
    { match: /\\/, replace: "\u05C0" }, // paseq

    // Shift state (uppercase)
    { match: /A/, replace: "ָ" },      // qamats
    { match: /B/, replace: "ב" },      // bet
    { match: /C/, replace: "ץ" },      // final tsadi
    { match: /D/, replace: "ד" },      // dalet
    { match: /E/, replace: "ֵ" },      // tsere
    { match: /F/, replace: "שׂ" },     // sin
    { match: /G/, replace: "ג" },      // gimel
    { match: /H/, replace: "ה" },      // he
    { match: /I/, replace: "ִ" },      // hiriq
    { match: /J/, replace: "שׁ" },     // shin
    { match: /K/, replace: "ך" },      // final kaf
    { match: /L/, replace: "ל" },      // lamed
    { match: /M/, replace: "ם" },      // final mem
    { match: /N/, replace: "ן" },      // final nun
    { match: /O/, replace: "ֹ" },      // holam
    { match: /P/, replace: "ף" },      // final pe
    { match: /Q/, replace: "\u0597" }, // revia
    { match: /R/, replace: "ר" },      // resh
    { match: /S/, replace: "ש" },      // shin (no dot)
    { match: /T/, replace: "ת" },      // tav
    { match: /U/, replace: "ֻ" },      // qubuts
    { match: /V/, replace: "ט" },      // tet
    { match: /W/, replace: "ו" },      // vav
    { match: /X/, replace: "ח" },      // het
    { match: /Y/, replace: "\u059F" }, // qarney para
    { match: /Z/, replace: "ז" },      // zayin
    { match: /,/, replace: "ע" },      // ayin (Shift+comma)
    { match: /\./, replace: "א" },     // alef (Shift+period)
    { match: /2/, replace: "\u0598" }, // zarqa
    { match: /3/, replace: "\u05A8" }, // qadma
    { match: /4/, replace: "\u059C" }, // geresh
    { match: /5/, replace: "\u059E" }, // gershayim
    { match: /7/, replace: "\u05AC" }, // iluy
    { match: /8/, replace: "\u059D" }, // geresh muqdam
];
